import { Alert } from "antd";
import React from "react";

type Props = { children: React.ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <Alert
          type="error"
          message="Something went wrong"
          description={this.state.error.message}
        />
      );
    }
    return this.props.children;
  }
}
